export enum ChasubleGothicType {
  EmbroideredOrphrey = 'embroidered_orphrey',
  PlainWithTrimmings = 'plain_with_trimmings',
  Galoon = 'galoon',
}
